<template>
    <div class="modal fade" ref="modal" data-bs-backdrop="static" tabindex="-1" aria-labelledby="erkModalLabel"
        aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">ATTENZIONE</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div v-if="isLoading">

                    </div>
                    <div v-else v-html="message">
                    </div>
                </div>
                <div v-if="!isLoading" class="modal-footer">
                    <button @click="onClickOk()" type="button" class="btn btn-primary close-btn">
                        Ok
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    props: {
        userId: Number
    },
    data() {
        return {
            isLoading: false,
            message: '',
            onClickOkHandler: null,
            myModal: null
        }
    },
    beforeUnmount() {
        if (this.myModal) {
            this.myModal.dispose()
        }
    },
    methods: {
        show(message, onClickOkHandler) {
            this.message = message
            this.onClickOkHandler = onClickOkHandler

            this.toggle()
        },
        toggle() {
            if (this.myModal == null) {
                this.myModal = new window.bootstrap.Modal(this.$refs.modal)
            }
            this.myModal.toggle()
        },
        onClickOk() {
            if (this.onClickOkHandler) {
                this.onClickOkHandler()
            }
            this.toggle()
        }
    }
}
</script>